enum SortOrder {
  NONE = "none",
  ASC = "ascending",
  DESC = "descending",
}

export default SortOrder;
